import React from 'react';
import type { MotorAd } from '../../../types';
import type { LabelRenderProps } from '../SearchAdPrimaryLabel';
import { SearchAdPrimaryLabel } from '../SearchAdPrimaryLabel';

const sortedLabelIds = [
    'sold',
    'rentedout',
    'smidig_bilhandel',
    'smooth_trade',
    'coming_for_sale',
];

type MotorLabelProps = {
    ad: MotorAd;
    className?: string;
    label?: (props: LabelRenderProps) => React.ReactElement | null;
};

export function MotorLabel(props: MotorLabelProps) {
    const { ad, className, label } = props;

    return (
        <SearchAdPrimaryLabel
            ad={ad}
            className={className}
            labelIds={sortedLabelIds}
            render={label ?? renderMotorLabel}
        />
    );
}

function renderMotorLabel({
    className = '',
    classes,
    label,
}: LabelRenderProps) {
    if (!label) {
        return null;
    }

    return (
        <>
            {label.id === 'sold' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'rentedout' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'smidig_bilhandel' && (
                <span
                    className={`${className} ${classes.badge} ${classes.positive}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'smooth_trade' && (
                <span
                    className={`${className} ${classes.badge} ${classes.neutral}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'coming_for_sale' && (
                <span
                    className={`${className} ${classes.badge} ${classes.info}`}
                >
                    {label.text}
                </span>
            )}
        </>
    );
}
